<app-topbar></app-topbar>
<app-sidebar></app-sidebar>
<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="dash-heading">
        <div>
          <h3 class="dash-title">Dashboard</h3>
          <p class="dash-greeting">{{ greeting }}, welcome back to your iCash Remit console.</p>
        </div>
        <span class="dash-date"><i class="fa fa-calendar-o"></i> {{ todayLabel }}</span>
      </div>
    </div>

    <div class="content-body">
      <!-- Key metrics -->
      <div class="dash-kpis" [ngClass]="{'dash-kpis--two': !canSeeBalance}">
        <a routerLink="/transactions" class="dash-kpi">
          <app-stat
            title="Total Transactions"
            [count]="data['total_transactions_count']"
            [amount]="data['total_amount']"
            accent="brand"
            icon="fa-bar-chart"
          ></app-stat>
        </a>

        <a [routerLink]="['/transactions', 'today']" class="dash-kpi">
          <app-stat
            title="Today's Transactions"
            [count]="data['total_transactions_today']"
            [amount]="data['total_transactions_amount_today']"
            accent="info"
            icon="fa-calendar-check-o"
          ></app-stat>
        </a>

        @if (canSeeBalance) {
          <div class="dash-kpi">
            <div class="inline-card inline-card--success">
              <span class="inline-card__icon"><i class="fa fa-money"></i></span>
              <div class="inline-card__body">
                <span class="inline-card__title">
                  {{ isSuperAdmin ? 'All Current Balance' : 'Balance' }}
                </span>
                <span class="inline-card__value">
                  NGN {{ isSuperAdmin ? (allIMTOBalance | number) : (balance | number) }}
                </span>
                @if (isSuperAdmin) {
                  <a class="inline-card__link" [routerLink]="['/agent']">
                    IMTO Partner Balances <i class="fa fa-chevron-right"></i>
                  </a>
                }
              </div>
            </div>
          </div>
        }

        @if (canSeeBalance) {
          <div class="dash-kpi">
            <div class="inline-card inline-card--info">
              <span class="inline-card__icon"><i class="fa fa-dollar"></i></span>
              <div class="inline-card__body">
                <span class="inline-card__title">Daily Dollar Exchange Rate</span>
                <span class="inline-card__value">NGN {{ $safeNavigationMigration(exchangeRate?.rate) | number }}</span>
                @if (isSuperAdmin) {
                  <span class="inline-card__meta">
                    Valid to {{ $safeNavigationMigration(exchangeRate?.valid_to) | date: 'MMM d, yyyy' }}
                    at {{ $safeNavigationMigration(exchangeRate?.valid_to) | date: 'HH:mm' }} GMT(+1)
                  </span>
                }
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Transaction status breakdown -->
      <h4 class="dash-section-title">
        <i class="fa fa-th-large"></i> Transaction Status
      </h4>
      <div class="dash-kpis">
        <a [routerLink]="['/transactions', 'new']" class="dash-kpi">
          <app-stat
            title="New Transactions"
            [count]="data['new_count']"
            [amount]="data['new_amount']"
            accent="neutral"
            icon="fa-inbox"
          ></app-stat>
        </a>
        <a [routerLink]="['/transactions', 'processing']" class="dash-kpi">
          <app-stat
            title="Processing"
            [count]="data['processing_count']"
            [amount]="data['processing_amount']"
            accent="warning"
            icon="fa-clock-o"
          ></app-stat>
        </a>
        <a [routerLink]="['/transactions', 'success']" class="dash-kpi">
          <app-stat
            title="Successful"
            [count]="data['successful_count']"
            [amount]="data['successful_amount']"
            accent="success"
            icon="fa-check-circle-o"
          ></app-stat>
        </a>
        <a [routerLink]="['/transactions', 'failed']" class="dash-kpi">
          <app-stat
            title="Failed"
            [count]="data['failed_count']"
            [amount]="data['failed_amount']"
            accent="danger"
            icon="fa-times-circle-o"
          ></app-stat>
        </a>
      </div>

      <!-- Charts -->
      <h4 class="dash-section-title">
        <i class="fa fa-pie-chart"></i> Analytics
      </h4>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-12">
          <div class="card dash-chart-card">
            <div class="card-header">
              <h4 class="card-title">Transaction Distribution</h4>
              <span class="dash-chart-sub">New, processing, successful &amp; failed share</span>
            </div>
            <div class="card-content collapse show">
              <div class="card-body">
                <app-pie></app-pie>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-12">
          <div class="card dash-chart-card">
            <div class="card-header">
              <h4 class="card-title">Daily Activity</h4>
              <span class="dash-chart-sub">Paid out, added &amp; failed transactions per day</span>
            </div>
            <div class="card-content collapse show">
              <div class="card-body">
                <app-graph></app-graph>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-bottombar></app-bottombar>
